
import { Navigate, Outlet} from "react-router-dom";


export const PrivateRoute = ({children}:any) => {
    const data = localStorage.getItem("userdata")||"false";
    const parsedData= JSON.parse(data)
    if (!parsedData.success) { 
      return <Navigate to={"/login"} />;
  } else {
      return children;
  }

};
